import 'element-plus/theme-chalk/src/base.scss';
//# sourceMappingURL=index.mjs.map
